// Handle status accordion
document.addEventListener('DOMContentLoaded', function () {

  // Check for weather request through data attribute
  let toggler = document.querySelectorAll('.course-status__toggler');
  if (!toggler) return;

  // Add event listener
  toggler.forEach(element => {
    element.addEventListener('click', function () {
      let accordion = this.nextElementSibling;
      if (!accordion) return;

      this.classList.toggle('active');
    });
  });
});
